<template>
  <b-modal
    v-model="showModal"
    centered
    header-class="custom-modal-header"
    footer-class="custom-modal-footer"
  >
    <template #modal-header>
      <p class="text-header">{{ $t("businessDay") }}</p>
    </template>
    <b-form>
      <InputSelectPlatformConfig
        v-if="useChannelBusinessHour"
        :title="$t('channel')"
        name="form.platformConfigId"
        isRequired
        v-model="form.platformConfigId"
        :options="platformConfigList"
        valueField="platformConfigId"
        textField="nameFull"
        @onDataChange="onChangePlatformConfig"
        :isValidate="v.form.platformConfigId.$error"
        :v="v.form.platformConfigId"
        :platformConfigId="platformConfigId"
      />
      <InputSelect
        :title="$t('businessDay')"
        name="form.dayId"
        isRequired
        v-model="form.dayId"
        :options="dateLists"
        valueField="id"
        textField="name"
        @onDataChange="onDateChangeDay"
        :isValidate="v.form.dayId.$error"
        :v="v.form.dayId"
      />
      <div class="mb-3">
        <div class="d-flex justify-content-between flex-column flex-sm-row">
          <div
            :class="['mb-2 mb-sm-0 ', { errorClass: v.form.startTime.$error }]"
          >
            <div>
              <span class="text-title">{{ $t("openTime") }}</span>
              <span class="text-danger">*</span>
            </div>
            <datetime
              class="date-picker-input"
              type="time"
              format="HH:mm"
              v-model="form.startTime"
              placeholder="HH:MM"
            />
            <div v-if="v.form.startTime && v.form.startTime.$error">
              <span
                class="text-error"
                v-if="v.form.startTime.required == false"
              >
                {{ $t("pleaseSelectOpenTime") }}
              </span>
            </div>
          </div>
          <div :class="{ errorClass: v.form.startTime.$error }">
            <div>
              <span class="text-title">{{ $t("closeTime") }}</span>
              <span class="text-danger">*</span>
            </div>
            <datetime
              class="date-picker-input"
              type="time"
              format="HH:mm"
              v-model="form.endTime"
              placeholder="HH:MM"
            />
            <div v-if="v.form.endTime && v.form.endTime.$error">
              <span class="text-error" v-if="v.form.endTime.required == false">
                {{ $t("pleaseSelectCloseTime") }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div>
        <toggle-button
          class="mt-1 mr-2"
          v-model="form.active"
          :color="{
            checked: '#27BDA7',
            unchecked: '#B0B0B0',
          }"
        />
        <span v-if="form.active" class="ml-2 f-size-18 text-header">
          Active
        </span>
        <span v-else class="ml-2 f-size-18 text-header">Inactive</span>
        <div v-if="v.form.active && v.form.active.$error">
          <span class="text-danger" v-if="v.form.active.required == false">
            {{ $t("pleaseSelectStatus") }}
          </span>
        </div>
      </div>
    </b-form>
    <template #modal-footer>
      <div class="w-100 d-flex justify-content-between">
        <button class="cancel-button" @click="onCloseModal">{{ $t("cancel") }}</button>
        <button class="save-button" @click="onSubmit()">{{ $t("save") }}</button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import InputSelect from "@/components/inputs/InputSelect";
import InputSelectPlatformConfig from "@/components/inputs/InputSelectPlatformConfig";
export default {
  name: "ModalCreateOrEditTime",
  components: {
    InputSelect,
    InputSelectPlatformConfig,
  },
  props: {
    form: {
      required: true,
      type: Object,
    },
    dateLists: {
      require: true,
      type: Array,
    },
    platformConfigList: {
      require: true,
      type: Array,
    },
    onSubmit: {
      require: true,
      type: Function,
    },
    v: {
      require: true,
      type: Object,
    },
    useChannelBusinessHour: {
      required: false,
      type: Boolean,
    },
    platformConfigId: {
      require: false,
      type: Number,
      default: 0,
    },
  },
  data: function () {
    return {
      showModal: false,
    };
  },
  methods: {
    show() {
      this.showModal = true;
    },
    onCloseModal() {
      this.showModal = false;
    },
    onDateChangeDay(value) {
      const getDate = this.dateLists.find((date) => date.id === value);
      this.form.name = getDate.name;
      this.form.dayId = getDate.id;
    },
    onChangePlatformConfig(value) {
      let platformConfig = this.platformConfigList.find(
        (platformConfig) => platformConfig.platformConfigId === value
      );
      this.form.platformConfigId = platformConfig.platformConfigId;
      this.form.platformConfigName = platformConfig.name;
    },
  },
};
</script>

<style lang="scss" scoped>
.errorClass > .dropdown-setting-date {
  border-color: red !important;
}
::v-deep .date-picker-input .vdatetime-input {
  padding: 5px 10px;
}
.text-title {
  color: #404040;
  font-size: 16px;
  margin-bottom: 2px;
  font-weight: bold;
}
::v-deep .dropdown-menu {
  min-width: 300px !important;
  max-width: 400px !important;
  padding: 10px !important;
  max-height: 50vh !important;
  overflow-y: auto;
  .dropdown-item {
    padding: 0.25rem 0;
  }
}
</style>
